// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bw-notification{height:auto;max-height:0;overflow:hidden;transition:max-height linear .35s;background-color:#fff}.bw-notification.bw-open{max-height:10rem}.bw-notification.bw-open.bw-expanded{max-height:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notification": "bw-notification",
	"open": "bw-open",
	"expanded": "bw-expanded"
};
module.exports = ___CSS_LOADER_EXPORT___;
